import React from 'react';
import { Box } from '@mui/material';

import { ActivityImage } from 'components/common/ActivityImage';
import { CameraState } from 'types/aspen/state';
import { AppDeviceLeaf } from 'types/common/leaf';

import styles from './cameraVideoPlaceholder.module.scss';

type CameraVideoPlaceholderTypes = 'preview' | 'normal';

interface CameraVideoPlaceholderProps {
  leaf: AppDeviceLeaf;
  isBatteryTimeout: boolean;
  cameraVideoPlaceholderType?: CameraVideoPlaceholderTypes;
}

export const CameraVideoPlaceholder = ({
  leaf,
  isBatteryTimeout,
  cameraVideoPlaceholderType = 'normal',
}: CameraVideoPlaceholderProps) => {
  const cameraState = leaf.state as CameraState;

  return (
    <Box
      className={`${styles.cameraVideoPlaceholder} ${styles[cameraVideoPlaceholderType]}`}
      data-testid="component-camera-video-placeholder"
    >
      {isBatteryTimeout && cameraState?.activity && (
        <ActivityImage activity={cameraState.activity} alt={`${leaf.name}-preview-img`} />
      )}
    </Box>
  );
};
